import { cn } from '@/lib/cn';

interface OperatorMarkProps {
  className?: string;
}

export function OperatorMark({ className }: OperatorMarkProps) {
  return (
    <svg
      viewBox="0 0 256 256"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      className={cn('shrink-0', className)}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M78 28 H178 C206 28 228 50 228 78 V178 C228 206 206 228 178 228 H78 C50 228 28 206 28 178 V78 C28 50 50 28 78 28 Z M78 78 V178 H178 V78 H78 Z"
      />
    </svg>
  );
}
